export default "__VITE_ASSET__DcBjeip___"